module.exports = __webpack_public_path__ + "static/media/increase.329a42cf.svg";